<mat-sidenav-container class="app-container">
    <mat-sidenav #sidenav mode="side" [opened]="!isSmallScreen">  
  <app-navigation (homeBtnClick)="sidenav.toggle()"></app-navigation>
</mat-sidenav>
<mat-sidenav-content>
  <app-header (homeBtnClick)="sidenav.toggle()"></app-header>
  <router-outlet></router-outlet>
</mat-sidenav-content>
</mat-sidenav-container>



